import { createStore } from 'vuex'
import general from '@/store/modules/general'

const modules = {
  general
}

export default new createStore({
  modules,
})
